"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAITING = exports.UDP_PROXY_SERVER = exports.TCP_PROXY_SERVER = exports.SKIPPED = exports.PERMISSION_DENIED = exports.PASSED = exports.NO_PROXY_SERVER = exports.NO_DEVICE_FOUND = exports.MICROPHONE_CHECK = exports.IN_USE = exports.FAILED = exports.DEVICE_CHECK = exports.CONNECTIVITY_CHECK = exports.CHECKING = exports.CAMERA_CHECK = exports.BROWSER_CHECK = void 0;
var PASSED = exports.PASSED = 'passed';
var FAILED = exports.FAILED = 'failed';
var CHECKING = exports.CHECKING = 'checking';
var WAITING = exports.WAITING = 'waiting';
var PERMISSION_DENIED = exports.PERMISSION_DENIED = 'permission_denied';
var SKIPPED = exports.SKIPPED = 'skipped';
var NO_DEVICE_FOUND = exports.NO_DEVICE_FOUND = 'no_device_found';
var IN_USE = exports.IN_USE = 'in_use';
var CAMERA_CHECK = exports.CAMERA_CHECK = 'camera';
var MICROPHONE_CHECK = exports.MICROPHONE_CHECK = 'microphone';
var CONNECTIVITY_CHECK = exports.CONNECTIVITY_CHECK = 'connectivity';
var DEVICE_CHECK = exports.DEVICE_CHECK = 'device';
var BROWSER_CHECK = exports.BROWSER_CHECK = 'browser';
var NO_PROXY_SERVER = exports.NO_PROXY_SERVER = 0;
var UDP_PROXY_SERVER = exports.UDP_PROXY_SERVER = 3;
var TCP_PROXY_SERVER = exports.TCP_PROXY_SERVER = 5;